import { ApiBaseURL } from '@zoomit/web-kit';

// Product
export const Product = `${ApiBaseURL}/catalog/api/products`;
export const Product_server = `${ApiBaseURL}/catalog/api/products`;

// physical store
export const PhysicalStore = `${ApiBaseURL}/catalog/api/physical-store-products`;

// Product Report
export const ProductReport = `${ApiBaseURL}/catalog/api/product-reports`;

// Brand
export const Brand = `${ApiBaseURL}/catalog/api/brands`;

// Store
export const Store = `${ApiBaseURL}/catalog/api/stores`;

// Comparisons
export const Comparisons = `${ApiBaseURL}/catalog/api/comparisons`;
export const PopularCategories = `${Comparisons}/popular-categories`;
export const RelatedComparisons = `${Comparisons}/related`;

// Category
export const Category = `${ApiBaseURL}/catalog/api/categories`;
export const CategoryWithoutGroups = `${ApiBaseURL}/catalog/api/categories/without-groups`;
export const CategoryGroup = `${ApiBaseURL}/catalog/api/category-groups`;

// Search
export const ProductSearch = `${ApiBaseURL}/catalog/api/search`;
export const CompareSearch = `${ProductSearch}/compare`;

// article search
export const ArticleSearchV2 = `${ApiBaseURL}/editorial/api/search/v2`;

// App Configs
export const ZoobinAppConfigs = 'https://public-config.theforge.ir/zoobin/app/config';

// App Download Request
export const appDownloadRequest = `${ApiBaseURL}/catalog/api/app-download-request`;
